import i18n from 'utils/i18n';

const CLIENT_STATUS_KEYS = {
  0: 'clients.status.standard',
  3: 'clients.status.newClient',
  6: 'clients.status.payOnline',
};

export const getClientStatuses = () =>
  Object.entries(CLIENT_STATUS_KEYS).map(([value, key]) => ({
    value: Number(value),
    name: i18n.t(key),
  }));

export const setCategory = (category) => {
  const key = CLIENT_STATUS_KEYS[category];
  return key ? i18n.t(key) : '';
};
